










































































import { Component, Vue } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
import { UserModule } from '@/store/modules/user';
import { AccountModule } from '@/store/modules/account';
import { AccountTypeEnum, AgentTypeEnum } from '@/api/types';
import { list_accounts } from '@/api/account';
import { list_agent_summaries, listAgentSummaries } from '@/api/agent';
import {
  stringFromIDate,
  stringToIDate,
  formatApiError,
  translateComponentResource,
} from '@/utils/index';
import { AppRoleType } from '@/utils/types';

type ItemType = {
  text: string;
  value: string;
};

@Component({
  name: 'AccountListSearch',
})
export default class AccountListSearch extends Vue {
  public static readonly accountSearchEvent = 'account-search';
  private valid = false;
  private openPanels = [0];
  private accountType = AccountTypeEnum.AGT as string;
  private accountTypeItems: ItemType[] = [];
  private agentId: string = '';
  private agentIdRules: ((v: string) => boolean | string)[] = [];
  private agentItems: ItemType[] = [];
  private includeInactive = false;

  get canShowAccountType() {
    return UserModule.roles.some(
      r =>
        (r as AppRoleType) === AppRoleType.ADMIN ||
        (r as AppRoleType) === AppRoleType.SUPPLIER ||
        (r as AppRoleType) === AppRoleType.SUPPLIER_VIEWER
    );
  }

  get canShowAgents() {
    return this.accountType === (AccountTypeEnum.AGT as string);
  }

  get canSearch() {
    return this.valid;
  }

  created() {
    this.loadAccountListSearchForm();
  }

  mounted() {
    this.fetchData();
    this.$nextTick(() => {
      this.loadRules();
      this.$nextTick(() => {
        if (this.canSearch) {
          this.search();
        }
      });
    });
  }

  private loadRules() {
    this.agentIdRules = [
      (v: string) =>
        !this.canShowAgents ||
        !!v ||
        (this.$t('{msg} is required', {
          msg: this.$t('Agent'),
        }) as string),
    ];
  }

  search() {
    const req: list_accounts.Request = {};
    if (this.accountType) {
      req.type = this.accountType as AccountTypeEnum;
    }
    if (req.type && (req.type as AccountTypeEnum) === AccountTypeEnum.AGT) {
      req.agentId = this.agentId;
    } else {
      req.agentId = 'dummy';
    }

    if (this.includeInactive) {
      req.includeInactive = true;
    }
    this.$emit(AccountListSearch.accountSearchEvent, req);

    AccountModule.SaveAccountListSearchForm({
      accountType: this.accountType,
      agentId: this.agentId,
      includeInactive: this.includeInactive,
    });
  }

  reset() {
    AccountModule.ClearAccountListSearchForm();
    (this.$refs.form as any).reset();
  }

  private loadAccountListSearchForm() {
    this.accountType = AccountModule.accountListSearchForm.accountType;
    this.agentId = AccountModule.accountListSearchForm.agentId;
    this.includeInactive = AccountModule.accountListSearchForm.includeInactive;
  }

  private async fetchData() {
    AppModule.StartProgress();
    this.loadAccountTypeItems();
    await this.loadAgentItems();
    AppModule.StopProgress();
  }

  private async loadAgentItems() {
    try {
      const listAgentsRes = await listAgentSummaries({
        agentTypes: Object.values(AgentTypeEnum).filter(
          t => (t as AgentTypeEnum) !== AgentTypeEnum.UNKNOWN_AGENT_TYPE
        ),
      } as list_agent_summaries.Request);
      const items: ItemType[] = [];
      listAgentsRes.agentSummaries.forEach(a => {
        items.push({
          text: a.name,
          value: a.id,
        });
      });
      this.agentItems = items;
    } catch (err) {
      this.$toast.error(
        this.$t('Failed to {do} due to {err}', {
          do: (this.$t('Fetch {msg}', {
            msg: this.$t('Agent'),
          }) as string).toLowerCase(),
          err: formatApiError(this.$i18n, err),
        }) as string,
        {
          icon: 'mdi-alert',
        }
      );
    }
  }

  private loadAccountTypeItems() {
    if (this.canShowAccountType) {
      this.accountTypeItems = [
        {
          text: this.$t(`AccountTypeEnum.${AccountTypeEnum.AGT}`) as string,
          value: AccountTypeEnum.AGT,
        },
        {
          text: this.$t(`AccountTypeEnum.${AccountTypeEnum.OCTB}`) as string,
          value: AccountTypeEnum.OCTB,
        },
      ];
    }
  }

  private translateComponentResource(resource: string) {
    return translateComponentResource(
      this.$i18n,
      this.$options.name as string,
      resource
    );
  }
}
